// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"EmailCapture_emailInput__otKbs","checkbox":"EmailCapture_checkbox__dI43S","checked":"EmailCapture_checked__yKmdj"};